/* Estimaciones compartidas. Despacho hasta las 12, también sábados y festivos; domingos no. */
(() => {
  'use strict';
  if (window.NebulabDelivery) return;
  const pretty = date => new Intl.DateTimeFormat('es-CO', { timeZone: 'UTC', day: 'numeric', month: 'short' }).format(date).replace('.', '');
  const iso = date => date.toISOString().slice(0, 10);
  const moveToMonday = date => {
    const moved = new Date(date);
    const day = moved.getUTCDay();
    if (day !== 1) moved.setUTCDate(moved.getUTCDate() + (day === 0 ? 1 : 8 - day));
    return moved;
  };
  const easterSunday = year => {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
  };
  const holidayCache = new Map();
  const colombianHolidays = year => {
    if (holidayCache.has(year)) return holidayCache.get(year);
    const dates = new Set();
    const add = date => dates.add(iso(date));
    [[0,1],[4,1],[6,20],[7,7],[11,8],[11,25]].forEach(([month,day]) => add(new Date(Date.UTC(year,month,day))));
    [[0,6],[2,19],[5,29],[7,15],[9,12],[10,1],[10,11]].forEach(([month,day]) => add(moveToMonday(new Date(Date.UTC(year,month,day)))));
    const easter = easterSunday(year);
    [-3,-2,39,60,68].forEach(offset => {
      const date = new Date(easter); date.setUTCDate(date.getUTCDate() + offset);
      add(offset < 0 ? date : moveToMonday(date));
    });
    holidayCache.set(year,dates); return dates;
  };
  const addBusinessDays = (date, days) => {
    const result = new Date(date);
    let count = 0;
    while (count < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      const weekday = result.getUTCDay();
      const holiday = colombianHolidays(result.getUTCFullYear()).has(iso(result));
      if (weekday !== 0 && weekday !== 6 && !holiday) count += 1;
    }
    return result;
  };

  function estimate(now = new Date()) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/Bogota',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'}).formatToParts(now).filter(p => p.type !== 'literal').map(p => [p.type,Number(p.value)]));
    const purchase = new Date(Date.UTC(parts.year,parts.month - 1,parts.day));
    const dispatch = new Date(purchase);
    if (parts.hour >= 12) dispatch.setUTCDate(dispatch.getUTCDate() + 1);
    while (dispatch.getUTCDay() === 0) dispatch.setUTCDate(dispatch.getUTCDate() + 1);
    return {purchase,dispatch,deliveryStart:addBusinessDays(dispatch,3),deliveryEnd:addBusinessDays(dispatch,5)};
  }
  let timer;
  function update() {
    clearTimeout(timer);
    if (document.hidden) return;
    const widgets = [...document.querySelectorAll('.neb-delivery[data-neb-delivery]')];
    if (!widgets.length) return;
    const dates = estimate();
    const state = window.NebulabStore?.get();
    const mode = state?.items.length ? state.mode : document.querySelector('[data-neb-catalog-mode]')?.value || state?.mode;
    widgets.forEach(widget => {
      widget.hidden = mode !== 'nacional';
      if (widget.classList.contains('neb-delivery--cart')) {
        const wrapper = widget.closest('.shopify-section');
        if (wrapper) wrapper.hidden = widget.hidden;
        const promos = wrapper?.previousElementSibling?.querySelector('[data-neb-promos-section]');
        if (promos && wrapper) wrapper.style.backgroundColor = getComputedStyle(promos).backgroundColor;
      }
      const purchase = widget.querySelector('[data-neb-date="purchase"]'), dispatch = widget.querySelector('[data-neb-date="dispatch"]');
      purchase.dateTime = iso(dates.purchase); purchase.textContent = pretty(dates.purchase);
      dispatch.dateTime = iso(dates.dispatch); dispatch.textContent = pretty(dates.dispatch);
      widget.querySelector('[data-neb-date="delivery"]').textContent = pretty(dates.deliveryStart) + ' – ' + pretty(dates.deliveryEnd);
    });
    if (widgets.some(widget => !widget.hidden)) timer = setTimeout(update,60000);
  }
  window.NebulabDelivery = Object.freeze({estimate,update});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',update,{once:true}); else update();
  ['neb:store-change','neb:store-ready','neb:catalog-mode','shopify:section:load','shopify:section:unload','visibilitychange'].forEach(name => document.addEventListener(name,update));
})();
